import accordion from './accordion'
import badge from './badge'
import button from './button'
import calendar from './calendar'
import card from './card'
import carousel from './carousel'
import checkbox from './checkbox'
import dropdownMenu from './dropdownMenu'
import formField from './formField'
import input from './input'
import link from './link'
import radioGroup from './radioGroup'
import select from './select'
import selectMenu from './selectMenu'
import switchButton from './switch'
import textarea from './textarea'

export default {
  button,
  link,
  accordion,
  select,
  input,
  selectMenu,
  carousel,
  textarea,
  formField,
  radioGroup,
  calendar,
  checkbox,
  switch: switchButton,
  card,
  badge,
  dropdownMenu,
}